// extracted by mini-css-extract-plugin
export var body = "_mg-5";
export var closeButton = "_mg-f";
export var container = "_mg-1";
export var content = "_mg-2";
export var cta = "_mg-c";
export var ctaLabel = "_mg-b";
export var eyebrow = "_mg-3";
export var howTo = "_mg-6";
export var image = "_mg-e";
export var modal = "_mg-0";
export var socialButton = "_mg-d";
export var stepCard = "_mg-8";
export var stepLabel = "_mg-a";
export var stepNumber = "_mg-9";
export var steps = "_mg-7";
export var title = "_mg-4";